// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChannelItem__pin-dc0f4d {
  width: 24px;
  height: 24px;
  fill: var(--base-60);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/GroupList/ChannelItem/ChannelItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF","sourcesContent":[".pin {\n  width: 24px;\n  height: 24px;\n  fill: var(--base-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pin": `ChannelItem__pin-dc0f4d`
};
module.exports = ___CSS_LOADER_EXPORT___;
